let loaded = false;
let loading = false;

let callbacks: (() => void)[] = [];

const RETRY_SLEEP_TIME = 10000;

export function load(): void {
  if (loaded || loading) {
    return;
  }

  loading = true;
  dispatch();
}

export const API_KEY = "AIzaSyBv3Vl9DjNyz7FL-fwrF4xhVnywG6phgF4";

function dispatch(): void {
  loadBrowser(API_KEY);
}

function loadBrowser(apiKey: string | null): void {
  const scriptTag = document.createElement("script");
  if (apiKey !== null) {
    scriptTag.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&libraries=places";
  } else {
    scriptTag.src = "https://maps.googleapis.com/maps/api/js?libraries=places";
  }
  scriptTag.onload = () => {
    loaded = true;
    for (const callback of callbacks) {
      callback();
    }
    // Don't cause a memory leak:
    callbacks = [];
  };
  scriptTag.onerror = () => {
    setTimeout(dispatch, RETRY_SLEEP_TIME);
  };
  document.head.appendChild(scriptTag);
}

export function onload(callback: () => void): void {
  if (loaded) {
    callback();
  }

  callbacks.push(callback);

  if (!loading) {
    load();
  }
}
